define('constants/signupOnboardingSelectionConstants',[], function() {
    return {
        'configureOnline': 'configureOnline',
        'onboardingCall': 'onboardingCall',
        'both': 'both'
    };
});

